import React from 'react';

const viDensityCompact = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path fill="currentColor" d="M1 1h22v2H1V1zm0 4h22v2H1V5zm0 4h22v2H1V9zm0 4h22v2H1v-2zm0 4h22v2H1v-2zm0 4h22v2H1v-2z" />
    </g>
  </svg>
);

export default viDensityCompact;
